import React from 'react';
import { motion } from 'framer-motion';
import { FaTrophy, FaRunning, FaSwimmer, FaFutbol, FaBasketballBall, FaTableTennis, FaDumbbell } from 'react-icons/fa';
import { GiTennisRacket, GiArcheryTarget } from 'react-icons/gi';
import { IoMdAmericanFootball } from 'react-icons/io';
import './sports.css';

const Sports = () => {
  const facilities = [
    {
      id: 1,
      name: "Olympic-Size Swimming Pool",
      description: "50-meter pool with diving facilities and certified instructors",
      // icon: <FaSwimmer size={40} />,
      image: "/logo192.png"
    },
    {
      id: 2,
      name: "FIFA Standard Football Field",
      description: "Full-size pitch with floodlights and seating for 1,000 spectators",
      // icon: <FaFutbol size={40} />,
          image: "/logo192.png"
    },
    {
      id: 3,
      name: "Indoor Basketball Arena",
      description: "NBA-standard court with electronic scoreboards",
      // icon: <FaBasketballBall size={40} />,
          image: "/logo192.png"
    },
    {
      id: 4,
      name: "High-Tech Gymnasium",
      description: "2,000 sqm facility with cardio and weight training zones",
      // icon: <FaDumbbell size={40} />,
          image: "/logo192.png"
    }
  ];

  const sportsTeams = [
    {
      name: "Dragons Football",
      achievements: "3-time Inter-University Champions",
      coach: "Coach Ahmad bin Ismail"
    },
    {
      name: "Phoenix Basketball",
      achievements: "National Collegiate Finalists 2023",
      coach: "Coach Zhang Wei"
    },
    {
      name: "Titans Swimming",
      achievements: "15 Gold Medals in ASEAN University Games",
      coach: "Coach Maria Santos"
    },
    {
      name: "Spartans Athletics",
      achievements: "Holds 8 national collegiate records",
      coach: "Coach Raj Patel"
    }
  ];

  const upcomingEvents = [
    {
      title: "Annual Sports Festival",
      date: "15-18 March 2024",
      location: "Main Sports Complex"
    },
    {
      title: "Inter-Faculty Football Cup",
      date: "5 April 2024",
      location: "University Stadium"
    },
    {
      title: "Asian Polytechnic Open Tennis",
      date: "22-25 May 2024",
      location: "Tennis Center"
    }
  ];

  const stats = [
    { value: "25+", label: "Sports Offered" },
    { value: "80%", label: "Student Participation" },
    { value: "15", label: "Varsity Teams" },
    { value: "12", label: "Championships Won" }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <motion.div 
      className="sports-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Hero Section */}
      <div className="sports-hero">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1> Sports Excellence at Asian Polytechnic</h1>
          <p className="hero-subtitle-para">Where champions are made - in the classroom and on the field</p>

          <div className="hero-stats">
            {stats.map((stat, index) => (
              <motion.div 
                key={index}
                className="stat-card"
                whileHover={{ scale: 1.05 }}
                variants={itemVariants}
              >
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>

        </motion.div>
      </div>



      {/* Varsity Teams */}
      <section className="teams-section">
        <div className="section-header">
          <h2> Varsity Teams</h2>
          <p>Representing Asian Polytechnic in national and international competitions</p>
        </div>
        
        <motion.div 
          className="teams-grid"
          variants={containerVariants}
        >
          {sportsTeams.map((team, index) => (
            <motion.div 
              key={index}
              className="team-card"
              variants={itemVariants}
              whileHover={{ scale: 1.03 }}
            >
              <div className="team-header">
  
                <h3>{team.name}</h3>
              </div>
              <div className="team-details">
                <p><strong>Achievements:</strong> {team.achievements}</p>
                <p><strong>Head Coach:</strong> {team.coach}</p>
              </div>
              <button className="team-btn">Join Team</button>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Upcoming Events */}
      <section className="events-section">
        <div className="section-header">
          <h2> Upcoming Sports Events</h2>
          <p>Join us as spectators or participants in these exciting competitions</p>
        </div>
        
        <motion.div 
          className="events-timeline"
          variants={containerVariants}
        >
          {upcomingEvents.map((event, index) => (
            <motion.div 
              key={index}
              className="event-card"
              variants={itemVariants}
              whileHover={{ scale: 1.02 }}
            >
              <div className="event-date">
                <div className="date-badge">{event.date.split(' ')[0]}</div>
                <div className="month-year">{event.date.split(' ')[1]}</div>
              </div>
              <div className="event-info">
                <h3>{event.title}</h3>
                <p><strong>Location:</strong> {event.location}</p>
                <button className="register-btn">Register Now</button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Sports Gallery */}
      <section className="gallery-section">
        <div className="section-header">
          <h2> Sports Gallery</h2>
          <p>Moments of glory and sportsmanship</p>
        </div>
        
        <motion.div 
          className="gallery-grid"
          variants={containerVariants}
        >
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <motion.div 
              key={item}
              className="gallery-item"
              variants={itemVariants}
              whileHover={{ scale: 1.03 }}
            >
              <img src={`/images/sports/gallery-${item}.jpg`} alt={`Sports moment ${item}`} />
              <div className="gallery-overlay">
                <button className="view-btn">View</button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Sports Philosophy */}
      <section className="philosophy-section">
        <motion.div 
          className="philosophy-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="philosophy-text">
            <h2>Our Sports Philosophy</h2>
            <p>At Asian Polytechnic, we believe sports are integral to holistic education. Our programs emphasize:</p>
            <ul>
              <li>Excellence in athletic performance</li>
              <li>Character development through sportsmanship</li>
              <li>Balance between academics and athletics</li>
              <li>Inclusivity and participation for all</li>
            </ul>
          
          </div>
          <div className="philosophy-image">
            <img src="/running.jpeg" alt="Sports Philosophy" />
          </div>
        </motion.div>
      </section>
    </motion.div>
  );
};

export default Sports;